export default [
  {
    path: 'profile',
    name: 'profile',
    component: () => import('./ProfilePage.vue')
  },
  {
    path: 'edit-email',
    name: 'edit-email',
    component: () => import('./edit-email/EditEmailProfile.vue')
  },
  {
    path: 'verify-email-profile',
    name: 'verify-email-profile',
    component: () => import('./edit-email/components/VerifyEmailProfile.vue')
  },
  {
    path: 'edit-phone',
    name: 'edit-phone',
    component: () => import('./edit-phone/EditPhoneNumber.vue')
  },
  {
    path: 'verify-phone-otp',
    name: 'verify-phone-otp',
    component: () => import('./edit-phone/VerifyPhoneOtp.vue')
  },
  {
    path: 'edit-personal',
    name: 'edit-personal',
    component: () => import('./edit-personal/EditPersonalInformationPage.vue')
  },
  {
    path: 'change-fullname',
    name: 'change-fullname',
    component: () => import('./edit-personal/components/ChangeProfileName.vue')
  },
  {
    path: 'change-email',
    name: 'change-email',
    component: () => import('./edit-personal/components/ChangeEmailProfile.vue')
  },
  {
    path: 'contact-us',
    name: 'contact-us',
    component: () => import('./contact-us/ContactUsPage.vue')
  },
  {
    path: 'terms-and-condition',
    name: 'terms-and-condition',
    component: () => import('./tnc/TnCPage.vue')
  },
  {
    path: 'privacy-policy',
    name: 'privacy-policy',
    component: () => import('./pnp/PnPPage.vue')
  },
  {
    path: 'change-pin',
    name: 'change-pin',
    component: () => import('./edit-pin/EnterCurrentPinPage.vue')
  },
  {
    path: 'create-new-pin',
    name: 'create-new-pin',
    component: () => import('./edit-pin/CreateNewPinPage.vue')
  },
  {
    path: 'confirm-new-pin',
    name: 'confirm-new-pin',
    component: () => import('./edit-pin/ConfirmNewPinPage.vue')
  }
]
